module.exports = __webpack_public_path__ + "static/media/beach.05a4d2a9.svg";